/** @jsxImportSource @emotion/react */

import { COLORS } from '@btime/constants'
import { css } from '@emotion/react'
import React from 'react'

import { truncateString } from '../../utils/helpers/string'
import breakpoints from '../../utils/constants/breakpoints'
import fontSizes, { fontComponents } from '../../utils/constants/fontSizes'

// TODO: Use useMemo to get styles only one time
const getStyle = props => {
  const {
    maxWidth,
    useMargin,
    noMargin,
    size,
    strong,
    color,
    inline,
    align,
    weight,
    italic,
    inlineBlock,
    bold,
    noWrap,
    hideOverflow,
    alignOnSm,
    sizeOnSm,
    preLine,
    breakWord,
    width,
    lineHeight,
    ...restProps
  } = props

  const style = css`
    &,
    & > a,
    h1&,
    h2&,
    h3&,
    h4& {
      margin-top: 0;
      margin-bottom: 0.55rem;
      font-family: system-ui, -apple-system, BlinkMacSystemFont, 'SF Pro Display', 'Nunito', 'Montserrat', sans-serif;
      overflow-wrap: break-word;
      line-height: ${lineHeight || 1.6};
      max-width: ${maxWidth}rem;
      color: ${color || COLORS.dark2};
      ${!!width ? 'width:' + width + ';' : ''}
      ${!!align ? 'text-align:' + align + ';' : ''}
			${!!bold || !!strong ? 'font-weight:700;' : ''}
			${!!weight ? 'font-weight:' + weight + ';' : ''}
			${!!inline ? 'display: inline;' : ''}
			${!!inlineBlock ? 'display: inline-block;' : ''}
			${!useMargin ? 'margin: 0;' : ''}
			${!!noMargin ? 'margin: 0;' : ''}
			${!!noWrap || !!hideOverflow ? 'white-space: nowrap;' : ''}
			${!!hideOverflow ? 'overflow: hidden;' : ''}
			${!!size ? 'font-size: ' + fontSizes[size] + 'rem;' : ''}
			${!!preLine ? 'white-space: pre-line;' : ''}
			${!!breakWord ? 'word-break: break-word;' : ''}

			& > a {
        color: ${COLORS.purple};
      }

      @media (max-width: ${breakpoints.sm}px) {
        ${alignOnSm ? `text-align: ${alignOnSm};` : ''}
        ${sizeOnSm ? `font-size: ${fontSizes[sizeOnSm]}rem;` : ''}
      }
    }

    & {
      display: block;
    }
  `
  return [style, restProps]
}

export const Text = ({ defaultSize, wrapper, size, className, truncate, children, ...props }) => {
  let wrapperTag = defaultSize || 'p'
  if (size) wrapperTag = size
  if (wrapper) wrapperTag = wrapper

  size = size || wrapperTag
  const Wrapper = fontComponents[wrapperTag]
  const content = truncate ? truncateString(children, truncate) : children

  const [style, restProps] = getStyle({ ...props, size })
  return (
    <Wrapper css={style} className={'text ' + className} {...restProps}>
      {content}
    </Wrapper>
  )
}

export const Title = props => <Text defaultSize="h1" useMargin {...props} />
export const SmallText = props => <Text defaultSize="small" {...props} />
export const Paragraph = props => <Text defaultSize="p" useMargin {...props} />
export const Label = props => <Text defaultSize="label" useMargin {...props} />
